// extracted by mini-css-extract-plugin
export var carrierTab = "_52-0";
export var carrierTabActive = "_52-1 _52-0";
export var carrierTabInactive = "_52-2 _52-0";
export var carrierTabLabel = "_52-3";
export var carrierTabLabelActive = "_52-4 _52-3";
export var carrierTabLabelInactive = "_52-5 _52-3";
export var carrierTabPercentage = "_52-6";
export var carrierTabPercentageActive = "_52-7 _52-6";
export var carrierTabPercentageInactive = "_52-8 _52-6";
export var carrierTabWinnable = "_52-9";
export var carrierTabWinnableActive = "_52-a _52-9";
export var carrierTabWinnableInactive = "_52-b _52-9";
export var comparisonContainer = "_52-d";
export var missingRateButton = "_52-n";
export var missingRateButtonActive = "_52-o _52-n";
export var missingRateButtonInactive = "_52-p _52-n";
export var missingRateButtonLabel = "_52-q";
export var missingRateButtonLabelActive = "_52-r _52-q";
export var missingRateButtonLabelInactive = "_52-s _52-q";
export var sidebar = "_52-c";
export var strategyButton = "_52-e";
export var strategyButtonActive = "_52-f _52-e";
export var strategyButtonDescription = "_52-k";
export var strategyButtonDescriptionActive = "_52-l _52-k";
export var strategyButtonDescriptionInactive = "_52-m _52-k";
export var strategyButtonInactive = "_52-g _52-e";
export var strategyButtonLabel = "_52-h";
export var strategyButtonLabelActive = "_52-i _52-h";
export var strategyButtonLabelInactive = "_52-j _52-h";
export var unitToggleButton = "_52-t";
export var unitToggleButtonActive = "_52-u _52-t";
export var unitToggleButtonInactive = "_52-v _52-t";
export var unitToggleButtonLabel = "_52-w";
export var unitToggleButtonLabelActive = "_52-x _52-w";
export var unitToggleButtonLabelInactive = "_52-y _52-w";